import type { StylePreset } from "@farzin/contracts";

const STYLES: readonly {
  readonly id: StylePreset;
  readonly label: string;
  readonly icon: string;
}[] = [
  { id: "neon-rain", label: "Neon Rain", icon: "▥" },
  { id: "cozy-night", label: "Cozy Night", icon: "⌂" },
  { id: "dream-garden", label: "Dream Garden", icon: "✦" },
  { id: "retro-space", label: "Retro Space", icon: "◇" },
];

export interface StylePickerProps {
  readonly value: StylePreset;
  readonly onChange: (value: StylePreset) => void;
}

export function StylePicker({
  value,
  onChange,
}: StylePickerProps): React.JSX.Element {
  return (
    <div className="style-grid" role="radiogroup" aria-label="Visual style">
      {STYLES.map((style) => (
        <button
          className={`style-card${value === style.id ? " selected" : ""}`}
          type="button"
          role="radio"
          aria-checked={value === style.id}
          key={style.id}
          onClick={() => onChange(style.id)}
        >
          <span className="style-icon">{style.icon}</span>
          <span>{style.label}</span>
        </button>
      ))}
    </div>
  );
}
